import React from 'react'
import DefaultForm from '../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../ui/gov-actions'
import { dayFormat } from '../../../week'
import { ForceSubmissionFields, ForceSubmissionDone } from './fields'

const available = record => hasAvailableAction(record, 'force_submissions')

const formEndPoint = ({ service_id, service_type }) =>
  process.env.REACT_APP_API_HOST + `/api/${service_type}/${service_id}/session-reports/force-submit-for-enrolment`

const validate = ({ care_id, enrolment_id }) => !!care_id && !!enrolment_id

const formValue = 'force_submissions'

const actionForm = ({ record, service_id, service_type, start_date }) => ({ handleSuccess }) => { 
  const { child_id } = record

  return(
    <DefaultForm
      url={formEndPoint({ service_id, service_type })}
      value={formValue}
      label="Attempt Force Submission"
      formOptions={{
        validate,
        defaultValues: {
          enrolment_id: undefined,
          week_start: dayFormat(start_date),
          care_id: undefined,
          late_reason: undefined
        },
      }}
      handleSuccess={payload => {
        return handleSuccess(
          { [formValue]: <ForceSubmissionDone errors={payload.errors} /> },
          formValue
        )
      }}
      formComponent={props => ForceSubmissionFields({...props, child_id, service_id })}
    />
  )
}

const forceSubmissionsForChild = ({
  record,
  service_id,
  service_type,
  refresh_session_reports,
  start_date,
}) =>
  available(record)
    ? {
      label: 'Force Submissions',
      value: formValue,
      actionForm: actionForm({ record, service_id, service_type, start_date }),
      onComplete: refresh_session_reports,
    }
    : null

export default forceSubmissionsForChild



// WEBPACK FOOTER //
// ./src/session-summaries/details/force-submissions/index.js